export const thumbnailWidth = 'w=130';
